import React, { useState, useEffect } from 'react';
import './ManageUsers.css'
import AuthService from './auth/AuthServices';

const MonitorLicenses = () => {
    const [licenseTypes, setLicenseTypes] = useState({});
    const [allLicenseData, setAllLicenseData] = useState('');
    const [allLicenseDataCurrentPage, setAllLicenseDataCurrentPage] = useState(1);
    const [allLicenseDataTotalPages, setAllLicenseDataTotalPages] = useState(1);
    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");

    useEffect(() => {
        getAllLicenseUsageData()
    }, [allLicenseDataCurrentPage])

    const getAllLicenseUsageData = async () => {
        try {
            const Response = AuthService.license_usage_data({
                page: allLicenseDataCurrentPage,
                per_page: 10,
                start_date: filterStartDate,
                end_date: filterEndDate
            })
            .then(async (res) => {
                if (res.status === 200 || res.status === 201) {
                    let data = await res.json()
                    setAllLicenseData(data.data)
                    setAllLicenseDataCurrentPage(data.current_page)
                    setAllLicenseDataTotalPages(data.pages)
                    console.log(allLicenseData)
                } else {
                    alert("Ein Fehler ist aufgettreten")
                }       
            })
        } catch (error) {
            console.error('An error occured:', error)
        }
    }

    const handleSearchLicenses = async (e) => {
        e.preventDefault();
        getAllLicenseUsageData();
    };
    
    const selectedLicenseTableKeys = ["Lizenz Key", "Verfallsdatum", "Vergleiche Anzahl"];

    return (
        <div className='container'>
            <div className='main-container'>
                <header className='header-filter'>
                    <label htmlFor="start-date" className="popup-label">
                        Start Datum:
                        <input
                            id="start-date"
                            type="text"
                            className="popup-input"
                            value={filterStartDate}
                            onChange={(e) => setFilterStartDate(e.target.value)}
                            placeholder="YYYY-MM-DD"
                        />
                    </label>

                    <label htmlFor="end-date" className="popup-label">
                        Ende Datum:
                        <input
                            id="end-date"
                            type="text"
                            className="popup-input"
                            value={filterEndDate}
                            onChange={(e) => setFilterEndDate(e.target.value)}
                            placeholder="YYYY-MM-DD"
                        />
                    </label>

                    <div>
                        <input className={'popup-submit-button'} type="button" onClick={handleSearchLicenses} value={'Suchen'} />
                    </div>
                </header>
                {allLicenseData && (
                    <div>
                        <h2 className='results-title'>Alle Lizenzen</h2>
                        <div className='all-results-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        {selectedLicenseTableKeys.map((key) => (
                                            <th key={key}>{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allLicenseData.licenses.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.license_key}</td>
                                            <td>{row.date_expiry}</td>
                                            <td>{allLicenseData.license_usage[row.license_key]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                <div className="pagination-container">
                    <button
                        className="pagination-button"
                        onClick={() =>
                            setAllLicenseDataCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={allLicenseDataCurrentPage === 1}
                        >
                        Previous
                    </button>

                    {Array.from({ length: allLicenseDataTotalPages }, (_, i) => (
                    <button
                        key={i + 1}
                        className={`pagination-button ${
                        allLicenseDataCurrentPage === i + 1 ? "active" : ""
                        }`}
                        onClick={() => setAllLicenseDataCurrentPage(i + 1)}
                    >
                        {i + 1}
                    </button>
                    ))}

                    <button
                        className="pagination-button"
                        onClick={() =>
                            setAllLicenseDataCurrentPage((prev) =>
                            Math.min(prev + 1, allLicenseDataTotalPages)
                            )
                        }
                        disabled={allLicenseDataCurrentPage === allLicenseDataTotalPages}
                        >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );

}; 

export default MonitorLicenses;